<template>
  <Modal title="专属投保地址" width="600" v-model="visible" class="my-modal directional-policy" :mask-closable="false" :footer-hide="true">
    <div class="right-box">
      <div class="title-box">
        <div class="text">您可获取以下链接、二维码放置您的推广场景中</div>
      </div>
      <div class="link-box" v-show="mLink">
        <div class="row">
          <div class="label">投保链接</div>
          <a class="text" :href="mLink" target="_blank">{{mLink}}</a>
          <div class="btn" @click="$units.copyUrl(mLink,false,true)">复制链接</div>
        </div>
        <div class="row">
          <div class="label">投保二维码</div>
          <vueQr :text="mLink" v-if="mLink" :size="200" :margin="0" ref="vueQr" />
          <div class="btn" @click="downloadImg()">下载二维码</div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import vueQr from "vue-qr";
export default {
  props: [],
  components: {
    vueQr
  },
  data() {
    return {
      visible: false,
      loading: false,
      mLink: '',
      data:{}
    }
  },
  mounted() {},
  methods: {
    // 打开弹窗
    open(data) {
      this.data = data;
      this.mLink = ''
      this.getStotLink(data.insureUrl);
    },
    getStotLink(url) {
      this.$notice.showLoading();
      this.$http({
        type: 'PUT',
        url: '/buz/orderImport/transformLongUrl',
        data: {
          url: url,
        },
      }).then((res) => {
        this.mLink = res.data
      }).finally(()=>{
        this.$notice.hideLoading();
        this.visible = true
      })
    },
    downloadImg(){
      const base64 = this.$refs.vueQr.$el.currentSrc;
      this.$units.dataToBlob(this.data.productName, base64);
    },
  },
}
</script>

<style lang="scss" scoped>
@import './directionalPolicy.scss';
.directional-policy.my-modal {
  .title-box {
    padding: 0;
  }
  .right-box{
    width: 410px;
    .link-box {
      .row .label {
        margin-top: 5px;
      }
      .btn {
        width: 90px;
        padding: 0 8px;  
        font-size: 14px;
        height: 30px;
        line-height: 28px;
        margin-top: auto;
      }
    }
  }
}
</style>
